<template>
  <div class="collection-filter">
    <p class="title">Explore the products</p>
    <ul class="collections">
      <li
        class="collections__item"
        v-for="collection in allCollections"
        :key="collection.handle"
        :class="{ active: currentCollection === collection.handle }"
      >
        <a @click.prevent="filter(collection)" :href="collection.url">{{
          collection.title
        }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CollectionFilter",
  selector: "#vue-collection-filter",
  props: {
    initialCollection: {
      type: String,
      required: true
    },
    collections: {
      type: Array,
      required: true
    },
    containerSelector: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      currentCollection: this.initialCollection
    };
  },

  methods: {
    async filter(collection) {
      const container = document.querySelector(this.containerSelector);
      container.classList.add("fetching");
      const { data } = await this.$http.get(collection.url);
      const tmp = document.createElement("div");
      tmp.innerHTML = data;
      const newContainer = tmp.querySelector(this.containerSelector);
      container.innerHTML = newContainer.innerHTML;
      container.classList.remove("fetching");
      this.currentCollection = collection.handle;
      window.history.replaceState({}, "", collection.url);
    }
  },

  computed: {
    allCollections() {
      return [
        { handle: "all", title: "View All", url: "/collections/all" },
        ...this.collections
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.collection-filter {
  @include inner-container();
  display: flex;
  align-items: center;
}

.title {
  font-size: 28px;
  font-weight: 700;
}

.collections {
  margin: 0 0 0 48px;
  padding: 0;
  display: flex;
  list-style: none;

  * + * {
    margin-left: 48px;
  }
}

.collections__item {
  font-size: 18px;
  a {
    color: $black;
    text-decoration: none;
  }
}

.active {
  font-weight: 700;
}
</style>